// common/publicRoutes.js

export const PUBLIC_PATHS = [
  "/",
  "/login",
  "/sign-up",
  "/un-authorized",
  "/forgot-password",
  "/reset-password",
  "/not-found",
  "/careers/offers",
];

const DYNAMIC_PUBLIC_PATHS = [
  "/reset-password",
  "/careers/offers",
];

export const isPublicPath = (pathname) => {
  if (!pathname) {
    if (typeof window !== "undefined") {
      pathname = window.location.pathname;
    } else {
      pathname = "/";
    }
  }

  return PUBLIC_PATHS.some((path) => {
    if (DYNAMIC_PUBLIC_PATHS.includes(path)) {
      return pathname.startsWith(path);
    }

    return pathname === path;
  });
};